(() => {
  'use strict';
  // PATAGONIA — couche mobile 27-10 (tout est réversible sur grand écran).
  // Le bandeau livraison reste collant : il est replié à 0 de hauteur en haut de
  // l'accueil et se déploie au défilement, le rendre statique le faisait disparaître.
  const media = window.matchMedia('(max-width: 749px)');
  const wrappers = new Map();
  const tuned = new Map();
  const moved = new Map();
  const prices = new Map();
  const labels = new Map();
  const navSwap = new Map();
  let filterBar = null;
  const CDN_TEST = new RegExp('(/cdn/shop/files/|cdn[.]shopify[.]com/s/files/)');
  const EXT_TEST = new RegExp('[.](png|jpg|jpeg|webp)([?]|$)', 'i');
  const EYEBROWS = '#MainContent .pc-craft-kicker, #MainContent .pc3v-kicker, #MainContent .pc-mix__eyebrow, #MainContent .pc-choice__eyebrow, #MainContent .pc-harmony__eyebrow, #MainContent .pc-discovery__eyebrow, #MainContent .pc-guide-hub__eyebrow, #MainContent .pc-growth__eyebrow, #MainContent .pc4-kicker, #MainContent .pc-home-tip__eyebrow';
  const FILTERS = [
    ['tous', 'Tous'], ['doux', 'Doux'], ['equilibre', 'Équilibrés'],
    ['corse', 'Corsés'], ['specialite', 'Spécialité']
  ];
  function catsOf(card) {
    const link = card.querySelector('a[href*="/products/"]');
    const href = link ? link.getAttribute('href') : '';
    const cats = [];
    if (/sol-andino|colombia|honduras/.test(href)) cats.push('doux');
    if (/signature|brasil/.test(href)) cats.push('equilibre');
    if (/ouro-preto|espresso/.test(href)) cats.push('corse');
    if (card.classList.contains('pc5-card')) cats.push('specialite');
    return cats;
  }
  function fold(node, label, className) {
    if (!node || wrappers.has(node) || node.closest('.pc-mobile-disclosure')) return;
    const marker = document.createComment('pcm27-position');
    const details = document.createElement('details');
    details.className = 'pc-mobile-disclosure ' + (className || '');
    const summary = document.createElement('summary');
    summary.textContent = label;
    const body = document.createElement('div');
    body.className = 'pc-mobile-disclosure__body';
    node.before(marker, details);
    details.append(summary, body);
    body.append(node);
    wrappers.set(node, { marker, details });
  }
  function unfold(selector) {
    document.querySelectorAll(selector).forEach(node => {
      const details = node.closest('details.pc-mobile-disclosure');
      if (!details || !details.parentElement) return;
      details.replaceWith(node);
    });
  }
  function tune(node, css) {
    if (!node || tuned.has(node)) return;
    const original = node.getAttribute('style') || '';
    tuned.set(node, original);
    node.setAttribute('style', original ? original + ';' + css : css);
  }
  function move(node, ref) {
    if (!node || !ref || moved.has(node)) return;
    const marker = document.createComment('pcm27-move');
    node.before(marker);
    ref.after(node);
    moved.set(node, marker);
  }
  // ===== Reconnaître un client déjà venu =====
  // 1. connecté avec au moins une commande (drapeau posé par Liquid, fiable)
  // 2. revenu par un lien de nos e-mails portant ?pc=client (témoin gardé sur l'appareil)
  // 3. sinon, visiteur nouveau : on met le Pack Découverte en avant
  function isKnownCustomer() {
    try {
      if (new URLSearchParams(window.location.search).get('pc') === 'client') {
        localStorage.setItem('pcm27-client', '1');
      }
    } catch (e) {}
    const flag = document.getElementById('pcm27-client');
    if (flag) {
      try { if (JSON.parse(flag.textContent).known === true) return true; } catch (e) {}
    }
    try { return localStorage.getItem('pcm27-client') === '1'; } catch (e) { return false; }
  }
  function tailorNav() {
    const known = isKnownCustomer();
    const pill = document.querySelector('.pcnav-shortcut-subscription');
    if (pill && !known && !navSwap.has(pill)) {
      navSwap.set(pill, { text: pill.textContent, href: pill.getAttribute('href') });
      pill.textContent = 'Pack découverte';
      pill.setAttribute('href', '/products/pack-decouverte');
    }
    const panel = document.querySelector('.pcnav-coffee-panel');
    if (panel && !panel.querySelector('.pcm27-sub-card')) {
      const card = document.createElement('a');
      card.className = 'pcnav-discovery-card pcm27-sub-card';
      card.setAttribute('href', '/pages/abonnement');
      const left = document.createElement('span');
      const small = document.createElement('small');
      small.textContent = 'Déjà votre préféré ?';
      const strong = document.createElement('strong');
      strong.textContent = 'Abonnement café';
      const note = document.createElement('span');
      note.textContent = 'Livré à votre rythme, sans engagement';
      left.append(small, strong, note);
      const end = document.createElement('span');
      end.className = 'pcnav-discovery-end';
      const arrow = document.createElement('strong');
      arrow.textContent = '→';
      end.append(arrow);
      card.append(left, end);
      const pack = panel.querySelector('a[href*="pack-decouverte"]');
      if (known && pack) pack.before(card);
      else if (pack) pack.after(card);
      else panel.append(card);
    }
  }
  function restoreNav() {
    navSwap.forEach((old, pill) => {
      pill.textContent = old.text;
      if (old.href) pill.setAttribute('href', old.href);
    });
    navSwap.clear();
    document.querySelectorAll('.pcm27-sub-card').forEach(c => c.remove());
  }
  function normalizeTypography() {
    document.querySelectorAll('#MainContent h2').forEach(h => {
      if (h.closest('.pcn')) return;
      if (parseFloat(window.getComputedStyle(h).fontSize) > 25) {
        tune(h, 'font-size:25px!important;line-height:1.12!important');
      }
    });
    document.querySelectorAll(EYEBROWS).forEach(k => {
      tune(k, 'font-size:10.5px!important;letter-spacing:0.16em!important;font-weight:700!important;line-height:1.3!important');
    });
  }
  function shortenLabels() {
    document.querySelectorAll('.pc4-card .pc4-actions a, .pc5-card .pc5-btn-orange').forEach(a => {
      if (labels.has(a)) return;
      if (!/^Choisir et commander$/i.test(a.textContent.trim())) return;
      labels.set(a, a.textContent);
      a.textContent = 'Commander';
    });
  }
  function splitPrices() {
    document.querySelectorAll('.pc4-card .pc4-price').forEach(node => {
      if (prices.has(node) || node.children.length) return;
      const text = node.textContent.trim();
      const parts = text.split('·').map(p => p.trim()).filter(Boolean);
      if (parts.length < 2) return;
      prices.set(node, text);
      node.textContent = '';
      parts.forEach((part, i) => {
        if (i) {
          const sep = document.createElement('span');
          sep.className = 'pcm27-sep';
          sep.textContent = ' · ';
          node.append(sep);
        }
        const span = document.createElement('span');
        span.className = 'pcm27-prix';
        span.textContent = part;
        node.append(span);
      });
    });
  }
  function slimLazyImages() {
    document.querySelectorAll('img[loading="lazy"]:not([srcset])').forEach(img => {
      if (img.complete && img.naturalWidth > 0) return;
      const src = img.getAttribute('src') || '';
      if (!CDN_TEST.test(src)) return;
      if (src.indexOf('width=') !== -1) return;
      if (!EXT_TEST.test(src)) return;
      img.setAttribute('src', src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=800');
    });
  }
  function catalogueSections() {
    return [...document.querySelectorAll('.shopify-section')].filter(s =>
      s.querySelector('.pc4-grid') || s.querySelector('.pc5-grid'));
  }
  function setFilter(name) {
    const cards = [...document.querySelectorAll('.pc4-card, .pc5-card')];
    if (filterBar) filterBar.querySelectorAll('button').forEach(b =>
      b.setAttribute('aria-pressed', b.dataset.pcmFilter === name ? 'true' : 'false'));
    if (name === 'tous') {
      document.body.classList.remove('pcm27-filtering');
      cards.forEach(c => c.classList.remove('pcm27-show'));
      document.querySelectorAll('.pcm27-ambiance-section').forEach(e =>
        e.classList.remove('pcm27-ambiance', 'pcm27-ambiance-section'));
      return;
    }
    document.body.classList.add('pcm27-filtering');
    cards.forEach(c => c.classList.toggle('pcm27-show', catsOf(c).includes(name)));
    document.querySelectorAll('.pc-selection-intro, .pc-discovery__offer, .pc2, .pc6').forEach(e =>
      e.classList.add('pcm27-ambiance', 'pcm27-ambiance-section'));
    catalogueSections().forEach(sec => {
      const visible = sec.querySelector('.pc4-card.pcm27-show, .pc5-card.pcm27-show');
      if (!visible) { sec.classList.add('pcm27-ambiance', 'pcm27-ambiance-section'); return; }
      sec.classList.remove('pcm27-ambiance');
    });
    const first = document.querySelector('.pc4-card.pcm27-show, .pc5-card.pcm27-show');
    if (first) {
      window.scrollTo({ top: first.getBoundingClientRect().top + window.scrollY - 200, behavior: 'smooth' });
    }
  }
  function placeFilterBar() {
    if (!filterBar) return;
    const strip = document.querySelector('.pcf-offer-strip');
    const head = document.querySelector('.shopify-section-header');
    const stripSticky = strip && ['sticky', 'fixed'].indexOf(window.getComputedStyle(strip).position) !== -1;
    filterBar.style.top = ((stripSticky ? strip.offsetHeight : 0) + (head ? head.offsetHeight : 0)) + 'px';
  }
  function buildFilterBar() {
    if (filterBar || !document.querySelector('.pc4-grid')) return;
    const anchor = [...document.querySelectorAll('.shopify-section')].find(s => s.querySelector('.pc4-grid'));
    if (!anchor) return;
    const nav = document.createElement('nav');
    nav.className = 'pcm27-filter';
    nav.setAttribute('aria-label', 'Filtrer les cafés');
    FILTERS.forEach(([value, label]) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.dataset.pcmFilter = value;
      b.textContent = label;
      b.setAttribute('aria-pressed', value === 'tous' ? 'true' : 'false');
      b.addEventListener('click', () => setFilter(value));
      nav.append(b);
    });
    anchor.before(nav);
    filterBar = nav;
    placeFilterBar();
    const wanted = (location.hash.match(/^#filtre-(doux|equilibre|corse|specialite)$/) || [])[1];
    if (wanted) setFilter(wanted);
  }
  function removeFilterBar() {
    if (filterBar) { filterBar.remove(); filterBar = null; }
    document.body.classList.remove('pcm27-filtering');
    document.querySelectorAll('.pcm27-show').forEach(e => e.classList.remove('pcm27-show'));
    document.querySelectorAll('.pcm27-ambiance-section').forEach(e =>
      e.classList.remove('pcm27-ambiance', 'pcm27-ambiance-section'));
  }
  function apply() {
    if (!media.matches) {
      wrappers.forEach(({ marker, details }, node) => { marker.replaceWith(node); details.remove(); });
      wrappers.clear();
      tuned.forEach((original, node) => {
        if (original) node.setAttribute('style', original); else node.removeAttribute('style');
      });
      tuned.clear();
      moved.forEach((marker, node) => marker.replaceWith(node));
      moved.clear();
      prices.forEach((text, node) => { node.textContent = text; });
      prices.clear();
      labels.forEach((text, node) => { node.textContent = text; });
      labels.clear();
      restoreNav();
      removeFilterBar();
      return;
    }
    document.querySelectorAll('.pcc-selected-benefits').forEach(node => {
      fold(node, 'Tout ce qui est inclus, en détail', 'pcm27-benefits');
    });
    document.querySelectorAll('.shopify-section[id*="page_cafe"] .taste').forEach(node => {
      fold(node, 'Les détails de dégustation', 'pcm27-taste');
    });
    document.querySelectorAll('#MainContent .pc6').forEach(node => {
      fold(node, 'Livraison : on participe à vos frais, le détail', 'pcm27-livraison');
    });
    unfold('.pc-pro .moments-section');
    unfold('.pc-pro .coffee-compact');
    document.querySelectorAll('.pc-home-craft h2').forEach(node => {
      tune(node, 'font-size:15.5px!important;line-height:1.22!important');
    });
    const horizon = document.getElementById('pc-horizon-title');
    if (horizon) {
      tune(horizon, 'font-size:23px!important;line-height:1.1!important;color:#FFF8EF!important');
      horizon.querySelectorAll('em').forEach(em => tune(em, 'color:#E8A765!important'));
    }
    const visual = document.querySelector('.pc-harmony__visual');
    const craft = document.querySelector('.pc-harmony .pc-craft-showcase');
    if (visual && craft) move(craft, visual);
    tailorNav();
    normalizeTypography();
    shortenLabels();
    splitPrices();
    slimLazyImages();
    buildFilterBar();
    placeFilterBar();
  }
  function init() { apply(); }
  media.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', () => { if (media.matches) placeFilterBar(); });
  window.addEventListener('hashchange', () => {
    const wanted = (location.hash.match(/^#filtre-(doux|equilibre|corse|specialite)$/) || [])[1];
    if (wanted && media.matches) { buildFilterBar(); setFilter(wanted); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();